import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromMedicatons from './medications.reducer';
import { EffectsModule } from '@ngrx/effects';
import { MedicationsEffects } from './medications.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromMedicatons.medicationsFeatureKey, fromMedicatons.reducer),
    EffectsModule.forFeature([MedicationsEffects]),
  ],
})
export class MedicationsStoreModule {}
